import { useState, useEffect, useLayoutEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import axios from 'axios';
import FileViewer from 'react-file-viewer';
import parse from 'html-react-parser';
import { Badge, Button, Modal, Table, Pagination, Input,Spin } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import 'react-data-grid/lib/styles.css';
import ReactDataGrid from 'react-data-grid';
import { Viewer } from 'react-doc-viewer';







const ProductView = () => {
  const [apiResponse, setApiResponse] = useState({});
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLinkModalOpen, setIsLinkModalOpen] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [htmlContent, setHtmlContent] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [fileArray, setFileArray] = useState([]);
  const [ext, setExt] = useState();
  const [sheetLink, setSheetLink] = useState('');
  const [modalFileName, setModalFileName] = useState('');
  // console.log('filearray', ext)
   const [error,setError] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useLayoutEffect(() => {
    getProducts();
    const userString = sessionStorage.getItem("kbs");
    const value = JSON.parse(userString);
    const paramValue = searchParams.get('reqU');
    // alert(paramValue)
    if (paramValue) {
      value.push(paramValue)
      sessionStorage.setItem("kbs", JSON.stringify(value));
    }
    // console.log('sess',value)
  }, []);

  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize, ext, modalFileName]);


  const supportedFileTypes = /\.(jpeg|jpg|png|gif|pdf|mp4|webm|ogg|xlsx|txt|docx)$/i;
  const backendDomain = `${process.env.REACT_APP_API_URL}`;



  const FilePreview = ({ fileUrls }) => {


    if (!fileArray) {
      return null; // If fileUrls is not defined or null, don't render anything
    }


    return (
      <div>
        {fileArray.map((url) => {
          const trimmedUrl = url.trim();
          // console.log('trimmedUrl',trimmedUrl)
          const isImageOrPdf = supportedFileTypes.test(trimmedUrl);
          // console.log('uuuurrrllll',trimmedUrl)
          const fullUrl = backendDomain + '/' + trimmedUrl.replace(/\\/g, '/');
          // Concatenate the backend domain with the fileUrl

          if (isImageOrPdf) {
            if (/\.(pdf)$/i.test(trimmedUrl)) {
              return (
                <div className='mb-4'>
                  <object
                    key={trimmedUrl}
                    data={fullUrl}
                    type="application/pdf"
                    width="100%"
                    height="500px"

                  >
                    <p>
                      Your browser does not support PDFs.
                      <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                        View PDF
                      </a>
                    </p>
                  </object>
                </div>
              );
            } else if (/\.(mp4|webm|ogg|mp3)$/i.test(trimmedUrl)) {
              return (
                <div className='mb-4'>
                  <video key={trimmedUrl} autoPlay controls width="100%" height="auto" src={fullUrl} />
                </div>
              );
            } else if (/\.(txt)$/i.test(trimmedUrl)) {
              // For text files, simply render the text content
              return (
                <div key={trimmedUrl} className='mb-4'>
                  <iframe title="Text File" src={fullUrl} width="100%" height="500px" />
                </div>
              );
            } else if (/\.(xlsx)$/i.test(trimmedUrl)) {
              // console.log('sdsdsdssd',trimmedUrl)
              // For docx and xlsx files, use react-file-viewer
              return (
                <div key={trimmedUrl} className='mb-4'>
                  <h1 className=''>Excel Data Viewer</h1>
                  <Table columns={columns} dataSource={excelData} pagination={false} />
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={pageSize * totalPages}
                    onChange={handlePageChange}
                    showSizeChanger
                  />
                </div>
              );
            } else if (/\.(docx)$/i.test(trimmedUrl)) {
              // For DOCX files, use the custom DocxViewer component
              return <div className=''>
                <h1>Document Viewer</h1>


              </div>;
            } else {
              return <img key={trimmedUrl} src={fullUrl} alt="Preview" />;
            }
          } else {
            // For non-supported file types, use react-file-viewer to display them in an iframe
            return (
              <div key={trimmedUrl} className='mb-4'>
                <FileViewer fileType={trimmedUrl.split('.').pop()} filePath={fullUrl} />
              </div>
            );

          }

        })}
      </div>
    );
  };





  const getProducts = async () => {

    try {
      const paramValue = searchParams.get('reqU');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/products/${paramValue}/0`);
      setApiResponse(response.data);
      // console.log('api res', response.data)
      setLoading(false);

      {
        response.data.fileUrl ? (
          response.data.fileUrl.split(',').map((filePath, index) => {
            const fileName = filePath.split('\\').pop();
            const filePathApi = fileName.split('.').pop();
            // console.log(fileName,filePathApi)
          })
        ) : (
        <div>No files available.</div>
      )
      }
    } catch (error) {
      console.log(error);
     
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      
    }
  };





  const fetchData = async () => {

    if (apiResponse) {
      try {

        const fileUrls = apiResponse.fileUrl.split(',');
        const xlsxFiles = fileUrls.filter(file => file.trim().endsWith('.xlsx'));
        const docxFiles = fileUrls.filter(file => file.trim().endsWith('.docx'));

        if (ext == 'xlsx') {
          xlsxFiles.forEach(async xlsxFile => {
            // console.log('vvvvvvvvvv',xlsxFile.trim().split('\\').pop())
            const docxFileName = xlsxFile.trim().split('\\').pop();
            const excelUrl = `${baseApiUrl}/getExcelData/${docxFileName}`;

            try {
              const response = await axios.get(`${baseApiUrl}/getExcelData/${modalFileName}.${ext}`, {
                params: {
                  page: currentPage,
                  pageSize: pageSize
                }
              });
              setExcelData(response.data.data);
              // console.log('dddddddddddddd',response.data.data)
              setTotalPages(response.data.totalPages);
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          });
        } else {
          docxFiles.forEach(async docxFile => {
            const docxFileName = docxFile.trim().split('\\').pop(); // Extract filename without path
            const docxUrl = `${baseApiUrl}/api/docx-to-html/${modalFileName}.${ext}`;
            try {
              const response = await axios.get(docxUrl);
              // Process the response as needed
              setHtmlContent(response.data)
            } catch (error) {
              console.error('Error fetching docx data:', error);
            }
          });
        }




        {
          apiResponse.fileUrl ? (
            apiResponse.fileUrl.split(',').map((filePath, index) => {
              const fileName = filePath.split('\\').pop();
              const filePathApi = fileName.split('.').pop();
              // console.log(fileName,filePathApi)
            })
          ) : (
          <div>No files available.</div>
        )
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const baseApiUrl = `${process.env.REACT_APP_API_URL}`;

  useEffect(() => {

  }, []);

  // MODAL METHODS

  const showModal = () => {
    setIsModalOpen(true);
  };
  const showLinkModal = () => {
    setIsLinkModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);

  };

  const handleOkLink = () => {
    setIsLinkModalOpen(false);
  };

  const allKeys = [...new Set(excelData.flatMap(obj => Object.keys(obj)))];

  const columns = excelData.length > 0 ? allKeys.map(key => ({
    title: key,
    dataIndex: key,
    key: key,
  })) : [];
  //...
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const modelHandler = (e) => {
    //  console.log(e.target.value)
    const dummyArray = [e.target.value, e.target.value];
    let extn = dummyArray[0].split('.');
    const fileNameWithoutExtension = extn[0].split('/').pop();
    //  console.log('extn url', fileNameWithoutExtension)
    setModalFileName(fileNameWithoutExtension)
    setExt(extn[1])
    setFileArray(dummyArray);
    showModal()

  }

  const linkHandler = (e) => {
    setSheetLink(e.target.value);
    showLinkModal()
  }
  // console.log('aaaaaaaaa', apiResponse)

  return (
    <div className="productView">
 {error && <div className='errorApi'>{error}</div>}
      <div className='leftProductColumn'>
        <Badge.Ribbon text={`Created At: ${apiResponse.createdAt}, Updated At: ${apiResponse.updatedAt}`} color='#1F3E77'>

          <div className='textEditorData'>

            {apiResponse.textEditor ? <div dangerouslySetInnerHTML={{ __html: apiResponse.textEditor }}></div> : null}
          </div>
        </Badge.Ribbon>
      </div>


      <div className='rightProductColumn'>
        <div className='rightDocInfoWrapper'>
          <div className="infoCard">
            <div className='infoTitle'>Document Description</div>
            <div className='postInfo'>
              <div><span>Title: </span><span>{apiResponse.title ? apiResponse.title : 'null'}</span></div>
              {/* <div><span>Department:  </span><span>{apiResponse.department ? apiResponse.department.name : 'null'}</span></div>
              <div><span>Category: </span><span>{apiResponse.subdepartment.name !== 'all' ? apiResponse.subdepartment.name : ''}</span></div> */}
              <div><span>Document Type: </span><span>{apiResponse.documentType ? apiResponse.documentType : 'null'}</span></div>
              <div><span>Posted By: </span><span>Admin</span></div>
              {apiResponse.menu ? <div><span>Posted for Menu: </span><span>{apiResponse.menu}</span></div> : null}
            </div>
          </div>
          {apiResponse.fileUrl && <div className="infoCard file">
            <div className='infoTitle'>Files</div>
            <div className='postInfo'>
              {apiResponse.fileUrl ? (
                apiResponse.fileUrl.split(',').map((filePath, index) => {
                  const fileName = filePath.split('\\').pop(); // Extract the file name from the path
                  return (
                    // <div key={index}>
                    //   <span>{fileName}</span><span><Button onClick={showModal}><EyeOutlined /></Button></span>
                    // </div>
                    <div key={index}>
                      <span>{fileName}</span><span><EyeOutlined /><Input id='viewProduct' value={filePath} onClick={modelHandler}></Input></span>
                    </div>
                  );
                })
              ) : (
                <div>No files available.</div>
              )}
            </div>
          </div>}
         {(apiResponse.spreadsheetLinks && apiResponse.spreadsheetLinks !== 'undefined') && apiResponse.spreadsheetLinks !== 'null' ?  <div className="infoCard linkDoc">
            <div className='infoTitle'>Linked Documents</div>
            <div className='postInfo'>
              {apiResponse.spreadsheetLinks ? (
                apiResponse.spreadsheetLinks.split(',').map((link, index) => (
                  <div key={index}>
                    <span>{link}</span><span><EyeOutlined /><Input id='viewProduct' value={link} onClick={linkHandler}></Input></span>
                  </div>
                ))
              ) : (
                <div>No linked documents available.</div>
              )}

            </div>
          </div>:null}
        </div>
      </div>
      <Modal title="File" className='fileMod' open={isModalOpen} onOk={handleOk} onCancel={handleOk}
        footer={[
          <Button key="back" onClick={handleOk}>
            Return
          </Button>
        ]} >
          
        <div>
          {ext !== 'docx' ? <div key={apiResponse.uuid} className="card">
            {apiResponse.fileUrl ? <FilePreview fileUrls={apiResponse.fileUrl} /> : null}
          </div> : null}
          {ext == 'docx' ? <div dangerouslySetInnerHTML={{ __html: htmlContent }} /> : null}
        </div>
       

      </Modal>


      <Modal title="File" className='fileMod' open={isLinkModalOpen} onOk={handleOkLink} onCancel={handleOkLink}
        footer={[
          <Button key="back" onClick={handleOkLink}>
            Return
          </Button>
        ]} >
         
        <div>
          <iframe
            src={sheetLink}
            width="100%"
            height="500"
            frameBorder="0"
            title="Google Sheet Embed"
          ></iframe>
        </div>
    
      </Modal>
    </div>
  )

}


export default ProductView